export const SPOTLIGHT_BLOCK_REVIEW_COUNT = 3
